import { TagSVG } from "@/components/svg";

export default function Tags({ tags }) {
  if (tags) {
    return (
      <div className="grid grid-cols-[20px_auto] items-center gap-x-4">
        <TagSVG className="mr-3 text-subheading-gray w-[20px] h-[20px]" />
        <div className="space-y-1">
          {tags.map((tag, index) => (
            <span key={tag} className="font-normal text-subheading-gray">
              {tag}
              {index !== tags.length - 1 && ", "}
            </span>
          ))}
        </div>
      </div>
    );
  }
}
